import DateHandlingBar from './components/DateHandlingBar';
import ShiftFilter from './components/ShiftFilter';
import Spinner from '../../components/Spinner';
import TyCalWeek from './components/CalWeek/TyCalWeek';
import WeekStatsHeader from './components/WeekStatsHeader';
import ShiftDetailModal from './components/ShiftDetailModal';
import TyCalDayOfWeekWithBadge from './components/CalWeek/TyCalDayOfWeekWithBadge';
import DaySummary from './components/DaySummary';
import useSearchString from '../../hooks/UrlParamsHandler/useSearchParams';
import { useIsFetching } from 'react-query';
import moment from 'moment';
import { queryKeyContains } from '../../utils/reactQueryUtils';

import { calendarContentBuilder } from './calendarPageUtils';
import { ShiftData } from '../../types/TymbeApi';
import classNames from 'classnames';

export const CalendarPageContent = ({
  shifts,
  isLoading,
  isFetched,
}: {
  shifts: ShiftData[];
  isLoading: boolean;
  isFetched: boolean;
}) => {
  const [searchParams] = useSearchString();
  const showShiftDetail = searchParams.get('shiftId') || undefined;
  const shiftDetailWidth = 385;
  const calendarIsFetching = useIsFetching({
    predicate: queryKeyContains('calendar'),
  });
  const start = searchParams.get('start') ?? moment().startOf('week').toISOString();

  return (
    <div className="flex w-full h-full @container">
      <div className="h-full flex flex-col flex-1">
        <div className="flex gap-3 p-3 bg-white items-center border-b border-secondary-100">
          <DateHandlingBar />
          <ShiftFilter />
          <Spinner className="size-4" show={!!calendarIsFetching} />
        </div>
        <div className="h-full w-full relative">
          <TyCalWeek
            headComp={TyCalDayOfWeekWithBadge}
            date={start}
            groupPosition="bottom"
            className={classNames(
              "absolute top-0 left-0 w-full h-full rounded grow [&_[data-day='6']]:bg-secondary-50 [&_[data-day='7']]:bg-secondary-50",
              { '@[1600px]:pr-0 pr-[385px]': showShiftDetail }
            )}
          >
            <TyCalWeek.Group flat position="bottom" className="bg-secondary-50">
              <TyCalWeek.Group.Head className="bg-secondary-50 flex !justify-center">
                <WeekStatsHeader />
              </TyCalWeek.Group.Head>
              <TyCalWeek.Header headComp={DaySummary} />
            </TyCalWeek.Group>
            {calendarContentBuilder(shifts, isLoading, isFetched)}
          </TyCalWeek>
          <ShiftDetailModal
            className={`absolute h-full right-0 max-[1000px]:w-full min-[1000px]:max-[1366px]:hidden w-[${shiftDetailWidth}px]`}
          />
        </div>
      </div>
    </div>
  );
};
